import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Clock from '@ast/magma/components/icon/icons/Clock';

import { ActionGroup, ActionGroupItem } from '@app/common/components/ActionGroup';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';
import { useUserTimeZone } from '@app/widgets/contacts-and-settings/hooks/useUserTimeZone';
import {
  useGetUserContactsSettingsQuery,
} from '@app/widgets/contacts-and-settings/queries/queryTyping/getUserContactSettings';
import { UrlParams } from '@app/widgets/contacts-and-settings/types';
import { getUrlToField } from '@app/widgets/contacts-and-settings/utils/paths';

import { ProfileAndSecurityFieldsListItem } from '../FieldsListItem';
import styles from '../ProfileAndSecurityFieldsList.pcss';

export const TIME_ZONE_SECTION_ID = 'TimeZone';

export const UserProfileList = () => {
  const { t } = useUserSettingsTranslation();
  const { data } = useGetUserContactsSettingsQuery();
  const { userTimeZone } = useUserTimeZone();
  const { sectionId } = useParams<UrlParams>();
  const history = useHistory();
  const isTimeZoneSectionEnabled = data?.userContactSettings.isChangeTimeZoneEnabled;

  if (!isTimeZoneSectionEnabled) {
    return null;
  }

  return (
    <div className={styles.group}>
      <h3 className={styles.title}>
        {t(
          'profile-and-security.profile-group.title|Profile group title text',
          'Profile',
        )}
      </h3>
      <ActionGroup>
        <ActionGroupItem
          className={styles.groupItem}
          iconClassName={styles.groupItemIcon}
          onSelect={() => {
            history.push(
              getUrlToField(
                sectionId,
                TIME_ZONE_SECTION_ID,
              ),
            );
          }}
        >
          <ProfileAndSecurityFieldsListItem
            icon={<Clock />}
            title={t(
              'profile-and-security.display-time-zone.label|Represents the label of the time zone item in the display mode',
              'Time zone',
            )}
            value={t(
              'profile-and-security.display-time-zone.value|Represents the display value of the time zone in the display mode',
              '{{name}}',
              { name: userTimeZone?.name },
            )}
          />
        </ActionGroupItem>
      </ActionGroup>
    </div>
  );
};
